import { message } from 'antd'
import { change } from 'redux-form'
import { approveRamsRecord } from '../../../../../HttpRequests/ramsRecords'
import fetchRamsRecords from '../../../../../Screens/ProjectView/Services/fetchRamsRecords'
import { FORM_NAME } from '../../../Form'
import _props from '../../../props'

export default (comment) => async (dispatch) => {

  const { ramsRecordId } = _props.get()

  if (!ramsRecordId) {
    message.warning('Please save the RAMS record first.')
    return
  }

  try {
    await approveRamsRecord(ramsRecordId, { comment })
    dispatch(change(FORM_NAME, 'status', 'approved'))
    dispatch(fetchRamsRecords())
    message.success('RAMS record has been approved.')
    _props.get().onClose()
  } catch (error) {
    const msg = error.response && error.response.data && error.response.data.error
      ? error.response.data.error
      : 'Failed to approve RAMS record'
    message.error(msg)
  }

}
